import LocationModel from './LocationModel';

export default class CounselingPreferencesModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.struggle_areas = (data.struggle_areas || []).map(
      (s) => new LocationModel(s)
    );
    this.gender_preference = data.gender_preference || '';
    this.race_preference = data.race_preference || '';
    this.lgbtq_preference = data.lgbtq_preference || false;
    this.religion_preference = data.religion_preference || '';
    this.language_preference = data.language_preference || '';
  }
}
